import { data, Link } from 'react-router-dom';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Box, Typography, Button, Container, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import "./App.css"; // CSSファイルをインポート
import api from './api';
import Header from './components/Header';
import HamburgerMenu from './components/Hamburger';
import { useConfirmBackLogout } from './common/useConfirmBackLogout';
import { createRoot } from "react-dom/client";
import Comp3PDF from "./Comp3PDF.js";
import Comp4PDF from "./Comp4PDF.js";
import Comp7PDF from "./Comp7PDF.js";
import Comp8PDF from "./Comp8PDF.js";
import Comp9PDF from "./Comp9PDF.js";
import Comp10PDF from "./Comp10PDF.js";
import Comp10_1PDF from "./Comp10_1PDF.js";
import Comp10_2PDF from './Comp10_2PDF.js';
import Comp11_2PDF from './Comp11_2PDF.js';
import Comp11PDF from "./Comp11PDF.js";
import Comp12PDF from "./Comp12PDF.js";
import Comp13PDF from "./Comp13PDF.js";
import Comp16PDF from './Comp16PDF.js';
import Comp17PDF from './Comp17PDF.js';
import Comp18PDF from './Comp18PDF.js';
import FormRequirePDF from "./FormRequirePDF";
import FormElectricityPDF from "./FormElectricityPDF.js";
import Comp5PDF from "./Comp5PDF.js"
import Comp6PDF from "./Comp6PDF.js"
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// import FormRequire from "./FormRequire";

const MyPage = () => {
  const [mypageData, setMypageData] = useState(null);
  const [statusData, setStatusData] = useState(null);
  const navigate = useNavigate();
  const [pdfReady, setPdfReady] = useState(false);
  const [noticeModalOpen, setNoticeModalOpen] = useState(true);
  const handleCloseNotice = () => setNoticeModalOpen(false);

  const [notices, setNotices] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const noticesPerPage = 5;

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        const res = await api.get(`/api/notices?skip=${(page - 1) * noticesPerPage}&limit=${noticesPerPage}`);
        setNotices(res.data.items);
        setTotal(res.data.total);
      } catch (err) {
        console.error('お知らせ一覧の取得に失敗:', err);
      }
    };
    fetchNotices();
  }, [page]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    const scrollToId = localStorage.getItem('scrollToId');
    if (scrollToId) {
      // requestAnimationFrame で描画完了後にスクロール
      requestAnimationFrame(() => {
        const el = document.getElementById(scrollToId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        localStorage.removeItem('scrollToId');
      });
    }
  }, []);

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res1 = await api.get(`/api/mypage/${user.mypage_id}`);
        const res2 = await api.get(`/api/submission-status/${user.mypage_id}`);
        setMypageData(res1.data);
        setStatusData(res2.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [canDownloadCertificate, setCanDownloadCertificate] = useState(false);

  const exId = mypageData?.exhibitor_id

  useEffect(() => {
    const fetchR2 = async () => {
      if (statusData?.r2_status !== "提出済み") return;

      try {
        const res = await api.get(`/api/forms/require_data/${exId}`);
        const r2 = res.data.r2 || {};

        setCanDownloadCertificate(
          !!r2.indoor_car || !!r2.car_certification
        );
      } catch (err) {
        console.error(err);
      }
    };
    fetchR2();
  }, [statusData, exId]);

  const downloadFile = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadBlobFile = (blob, filename) => {
    const blobUrl = window.URL.createObjectURL(blob);
    downloadFile(blobUrl, filename);
    window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
  };

  const extractFilename = (contentDisposition) => {
    if (!contentDisposition) return null;

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
      return decodeURIComponent(utf8Match[1]);
    }

    const asciiMatch = contentDisposition.match(/filename=\"?([^\";]+)\"?/i);
    return asciiMatch?.[1] || null;
  };

  const handleDownloadCertificates = async () => {
    try {
      const res = await api.post(
        "/api/r2-certificate-download",
        { exhibitor_id: exId },
        { responseType: "blob" }
      );

      const filename =
        extractFilename(res.headers?.["content-disposition"]) ??
        "r2-certificates.zip";

      downloadBlobFile(res.data, filename);
    } catch (err) {
      console.error(err);
      alert("証票ファイルの作成に失敗しました");
    }
  };

  const getImageByStatus = (status) => {
    switch (status) {
      case '再提出':
        return "/status_再提出.png";
      case '確認済':
        return "/status_確認済み.png"; 
      case '提出済み':
        return "/status_確認中.png";
      case '未提出':
        return "/status_未提出.png";
      case '申請しない':
        return "/status_申請しない.png"; 
      default:
        return "/status_未提出.png";
    }
  };

  const getPreferredStatus = (status, hostStatus) => {
    return hostStatus === "確認済" ? "確認済" : (status || "未提出");
  };

  // const getPreferredStatusForElec = (o5Status, o6Status, o5HostStatus, o6HostStatus) => {
  //   // 両方申請しない
  //   if (o5Status === "申請しない" && o6Status === "申請しない") {
  //     return "申請しない";
  //   }

  //   // 両方またはどちらかが確認済
  //   if (
  //     (o5HostStatus === "確認済" && o6HostStatus === "申請しない") ||
  //     (o5HostStatus === "申請しない" && o6HostStatus === "確認済") ||
  //     (o5HostStatus === "確認済" && o6HostStatus === "確認済")
  //   ) {
  //     return "確認済";
  //   }

  //   // 再提出が含まれる場合（どちらかでも）
  //   if (
  //     o5Status === "再提出" ||
  //     o6Status === "再提出" ||
  //     o5HostStatus === "再提出" ||
  //     o6HostStatus === "再提出"
  //   ) {
  //     return "再提出";
  //   }

  //   // どちらかが提出済みで、もう一方が申請しない
  //   if (
  //     (o5Status === "提出済み" && o6Status === "申請しない") ||
  //     (o5Status === "申請しない" && o6Status === "提出済み") ||
  //     (o5Status === "提出済み" && o6Status === "提出済み")
  //   ) {
  //     return "提出済み";
  //   }

  //   // 両方未提出
  //   if (o5Status === "未提出" && o6Status === "未提出") {
  //     return "未提出";
  //   }

  //   // デフォルト
  //   return "未提出";
  // };

  const [isHovered, setIsHovered] = useState(false);

   const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展概要(規定)', path: '/しんきんビジネスフェア2026出展概要_0709.pdf' },
      { label: '会場平面図', path: '/会場平面図.pdf' },
      { label: '荷物の発送について', path: '/荷物の発送について.pdf' },
      { label: 'お弁当について', path: '/お弁当について.pdf' },
      { label: '宿泊のご案内', path: '/宿泊のご案内.pdf' },
      { label: '来場者カード一覧', path: '/来場者カード一覧.pdf' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者申請システムログイン方法', path: '/出展社申請システムログイン方法.pdf' },
      // { label: '各種届出提出方法', path: '/各種届出提出方法.pdf' },
      // { label: '出展者証について', path: '/出展者証について.pdf' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];

    const deadline = new Date("2026-09-30T23:59:59");
    const today = new Date();
    const now = new Date(); // 現在の日時

    // 残り日数計算
    const remainingDays = Math.ceil((deadline - today) / (1000 * 60 * 60 * 24));

   const renderMenuItems = () => (
        <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
            <div className="submenu">
              {pdfItems.map((item, index) => (
                <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
                </a>
              ))}
            </div>
          )}
        </div>
    );

    const handlePdfDownload = async (exhibitorId, companyName) => {
      try {
        const response = await api.get(
          `/api/pdf-download/${exhibitorId}`,
          {
            responseType: 'blob',
            headers: {
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0'
            },
            params: {
              companyName,
              t: new Date().getTime()
            }
          }
        );

        const blob = new Blob([response.data], { type: 'application/zip' });
        const safeFileName = companyName.replace(/[\\/:*?"<>|]/g, '_') + '_pdfs.zip';

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', safeFileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        alert("PDFのダウンロードが完了しました。");
      } catch (error) {
        console.error("PDFダウンロードに失敗:", error);
        alert("PDFのダウンロードに失敗しました。");
      }
    };

    useEffect(() => {
      if (!mypageData?.exhibitor_id) return;

      // Excel/PDF があるか事前チェック
      api.get(`/api/pdf-exists/${mypageData?.exhibitor_id}`)
        .then(res => setPdfReady(res.data.exists))
        .catch(() => setPdfReady(false));
    }, [mypageData?.exhibitor_id]);

    console.log(pdfReady)

    const canDownload =
      pdfReady 

    console.log(statusData)

    useConfirmBackLogout(navigate);

    const FIELD_CONFIGS = [
      {
        key: 'r1',
        label: '出展者責任届等',
        category: 1,
      },
      {
        key: 'o3',
        label: '運送・会場内荷役',
        category: 3,
      },
      {
        key: 'o4',
        label: '床面工事',
        category: 4,
      },
      {
        key: 'o5',
        label: '電気使用',
        category: 5,
      },
      {
        key: 'o6',
        label: '電気備品',
        category: 6,
      },
      {
        key: 'o7',
        label: '給排水・エア・ガス',
        category: 7,
      },
      {
        key: 'o8',
        label: 'パッケージ装飾',
        category: 8,
      },
      {
        key: 'o9',
        label: '装飾備品レンタル',
        category: 9,
      },
      {
        key: 'o10',
        label: 'PC・ソフトレンタル',
        category: 10,
      },
      {
        key: 'o10_2',
        label: 'インターネット接続',
        category: 14,
      },
      {
        key: 'o11',
        label: '危険物品',
        category: 11,
      },
      {
        key: 'o11_2',
        label: '防炎対象物',
        category: 15,
      },
      {
        key: 'o12',
        label: 'ゴミ・廃材・廃油処理',
        category: 12,
      },
      {
        key: 'o13',
        label: 'ブース平面図',
        category: 13,
      },
      {
        key: 'o16',
        label: '食品取扱関係調査票',
        category: 16,
      },
      {
        key: 'o17',
        label: '物品販売等',
        category: 17,
      },
      {
        key: 'r18',
        label: 'キャッチコピー',
        category: 18,
      },
    ];
    const [rentalItems, setRentalItems] = useState([]);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const res = await api.get("/api/master/items-o9");
                setRentalItems(res.data || []);
            } catch (err) {
                console.error("アイテム取得エラー:", err);
            }
        };
        fetchItems();
    }, []);

    const [pcItems, setPcItems] = useState([]);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const res = await api.get("/api/master/items-o10");
                setPcItems(res.data || []);
            } catch (err) {
                console.error("アイテム取得エラー:", err);
            }
        };
        fetchItems();
    }, []);

    const [elecItems, setElecItems] = useState([]);
    useEffect(() => {
        const fetchItems = async () => {
            try {
                const res = await api.get("/api/master/items");
                setElecItems(res.data || []);
            } catch (err) {
                console.error("アイテム取得エラー:", err);
            }
        };
        fetchItems();
    }, []);
    const [gasChecked, setGasChecked] = useState({
      water: false,
      air: false,
      gas: false,
    });
    const [checked, setChecked] = useState({
      pack: false,
      storage: false,
      iphone: false,
      add: false,
    });
    const [cleanChecked, setCleanChecked] = useState({
      garbage: false,
      oil: false,
      clean: false,
    });
    const [checkedPC, setCheckedPC] = useState({
      pc: false
    });
    const [selectedPlans, setSelectedPlans] = useState([]);
    const waitForIdleAndStableDOM = (targetElement, timeout = 3000) =>
      new Promise((resolve) => {
        let stableCount = 0;
        let lastHeight = targetElement.offsetHeight;

        const checkStable = () => {
          const nowHeight = targetElement.offsetHeight;
          if (nowHeight === lastHeight) {
            stableCount++;
            if (stableCount >= 3) {
              return resolve();
            }
          } else {
            stableCount = 0;
            lastHeight = nowHeight;
          }
          setTimeout(checkStable, 150);
        };

        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => {
            setTimeout(checkStable, 150);
          }, { timeout });
        } else {
          setTimeout(checkStable, 150);
        }
    });
    const [checkedPdfIds, setCheckedPdfIds] = useState([]);
    const isCheckable = (key) => {
      const status = statusData?.[`${key}_status`];

      return ![
        "",
        undefined,
        null,
        "未提出",
        "申請しない",
      ].includes(status);
    };
    const handleColumnSelect = () => {
      const keys = FIELD_CONFIGS
        .map((field) => field.key)
        .filter((key) => isCheckable(key));

      const allChecked = keys.every((key) =>
        checkedPdfIds.includes(key)
      );

      setCheckedPdfIds((prev) => {
        if (allChecked) {
          return prev.filter((id) => !keys.includes(id));
        }

        return [...new Set([...prev, ...keys])];
      });
    };
    const togglePdfCheck = (key) => {
      if (!isCheckable(key)) return;

      setCheckedPdfIds((prev) =>
        prev.includes(key)
          ? prev.filter((k) => k !== key)
          : [...prev, key]
      );
    };
    const handlePDFDownload = async () => {
      const fieldMap = Object.fromEntries(FIELD_CONFIGS.map(f => [f.key, f]));
      if (!mypageData?.exhibitor_id) return;

      const fetchCorporateInfo = async () => {
        try {
          const res = await api.get(`/api/pdf-mine/${mypageData?.exhibitor_id}`);

          if (res.status !== 200) {
            throw new Error("データ取得に失敗しました");
          }

          return res.data;
        } catch (err) {
          console.error("API呼び出し失敗:", err);
          throw err;
        }
      };
      

      const corporateInfo = await fetchCorporateInfo();
      const corporateDataMap = corporateInfo.data;
      const selectedKeys = checkedPdfIds;
      // これは仮。あとで選択したPDF

      const targets = selectedKeys.map((key) => {
        const fieldConfig = fieldMap[key];
        if (!fieldConfig) return null;

        const category = fieldConfig.category;
        const forms = corporateDataMap[category];
        if (!forms) return null;

        const matchedForm = forms.find(f => f.exhibitor_id === mypageData.exhibitor_id);
        if (!matchedForm) return null;

        return {
          exhibitor_id: mypageData.exhibitor_id,
          company_name: matchedForm.company_name,
          selectedCategories: [key],
          categories: {
            [key]: matchedForm,
          }
        };
      }).filter(Boolean);

      if (!targets.length) return alert("出力対象が選択されていません");
      // console.log(targets);

      // --- user_id を取得して User0 を付与 ---
      const fetchUserId = async (exhibitor_id) => {
        try {
          const res = await api.get(`/api/users/${exhibitor_id}`);
          if (res.status === 200) {
            return res.data.user_id;
          }
        } catch (err) {
          console.error("user_id取得失敗:", err);
        }
        return null;
      };

      const targetsWithUser0 = await Promise.all(
        targets.map(async (row) => {
          const user_id = await fetchUserId(row.exhibitor_id);
          return {
            ...row,
            User0: user_id === 0, // user_id=0ならtrue
          };
        })
      );

      const pdfBlobs = [];

      for (const row of targetsWithUser0) {
        for (const fieldKey of row.selectedCategories) {
          const form = row.categories[fieldKey];
          const fieldConfig = fieldMap[fieldKey];

          // console.log(form);

          const reqData = {
            company_name: form.company_name,
            booth_number: form.booth_number,
            department: form.department,
            address: form.address,
            phone_number: form.phone_number,
            email: form.email,
            user_name: form.user_name,
            r1: form.r1?.[0] || {},
            r2: form.r2?.[0] || {},
          };

          const elecData = {
            company_name: form.company_name,
            booth_number: form.booth_number,
            department: form.department,
            address: form.address,
            phone_number: form.phone_number,
            email: form.email,
            user_name: form.user_name,
            o5: form.o5?.[0] || {},
            o6: form.o6?.[0] || {},
          };

          if (!fieldConfig) continue;

          const container = document.createElement("div");
          document.body.appendChild(container);
          const root = createRoot(container);

          const renderComponent = (formKey) => {
            switch (formKey) {
              case 'r1':
                const hasPackage = !!(
                  reqData?.r1?.package_company_name ||
                  reqData?.r1?.package_company_tel ||
                  reqData?.r1?.package_phone_number ||
                  reqData?.r1?.package_company_zip ||
                  reqData?.r1?.package_company_address ||
                  reqData?.r1?.package_company_fax ||
                  reqData?.r1?.package_name
                );

                const hasElec = !!(
                  reqData?.r1?.elec_company_name ||
                  reqData?.r1?.elec_company_tel ||
                  reqData?.r1?.elec_phone_number ||
                  reqData?.r1?.elec_company_zip ||
                  reqData?.r1?.elec_company_address ||
                  reqData?.r1?.elec_company_fax ||
                  reqData?.r1?.elec_name
                );

                const hasInfla = !!(
                  reqData?.r1?.infla_company_name ||
                  reqData?.r1?.infla_company_tel ||
                  reqData?.r1?.infla_phone_number ||
                  reqData?.r1?.infla_company_zip ||
                  reqData?.r1?.infla_company_address ||
                  reqData?.r1?.infla_company_fax ||
                  reqData?.r1?.infla_name
                );

                const hasCargo = !!(
                  reqData?.r1?.cargo_company_name ||
                  reqData?.r1?.cargo_company_tel ||
                  reqData?.r1?.cargo_phone_number ||
                  reqData?.r1?.cargo_company_zip ||
                  reqData?.r1?.cargo_company_address ||
                  reqData?.r1?.cargo_company_fax ||
                  reqData?.r1?.cargo_name
                );

                // まとめる
                const checkedR1 = {
                  has_package_company: hasPackage,
                  has_elec_company: hasElec,
                  has_infla_company: hasInfla,
                  has_cargo_company: hasCargo,
                };
                return <FormRequirePDF reqData={{ 
                  ...reqData, 
                  r1: { ...reqData.r1, ...checkedR1 } 
                }} User0={row.User0} />;
              case 'o3':
                return <Comp3PDF formData={form} />;
              case 'o4':
                return <Comp4PDF formData={form} />;
              case 'o5':
                const hasV100 =
                  form?.o5?.[0]?.details_100?.some(d =>
                    d.device_100_name || d.quantity_100 || d.number_100 || d.total_100 || d.ex_100
                  ) ||
                  (form?.o5?.[0]?.quantity_100v !== null &&
                  form?.o5?.[0]?.quantity_100v !== undefined &&
                  Number(form?.o5?.[0]?.quantity_100v) > 0);

                const hasV200 =
                  form?.o5?.[0]?.details_200?.some(d =>
                    d.device_200_name || d.quantity_200 || d.number_200 || d.total_200 || d.ex_200
                  ) ||
                  (form?.o5?.[0]?.quantity_200v !== null &&
                  form?.o5?.[0]?.quantity_200v !== undefined &&
                  Number(form?.o5?.[0]?.quantity_200v) > 0);

                const localChecked = {
                  v100: !!hasV100,
                  v200: !!hasV200
                };

                return <Comp5PDF elecData={form} checked={localChecked} elecItems={elecItems} />;
              case 'o6':
                return <Comp6PDF elecData={form} elecItems={elecItems} />;
              case 'o7':
                const hasWater = form.water_using || form.water_quantity || form.water_pipe || form.water_ex_pipe;
                const hasAir = form.air_pascal || form.air_wind || form.air_device || form.bulb;
                const hasGas = form.gas;

                const gasObj = {
                  water: !!hasWater,
                  air: !!hasAir,
                  gas: !!hasGas,
                };

                setGasChecked(gasObj);
                return <Comp7PDF formData={form} checked={gasObj} />;
            case 'o8':
              let plans = [];
              if (form.plan && Array.isArray(form.plan)) {
                plans = form.plan.map(p => ({
                  value: p.value,
                  label: p.label,
                  quantity: p.quantity || 1,
                }));
                setSelectedPlans(plans); // ← stateに残したいならここはそのまま
              }

              const hasPack = plans.length > 0 ||
                form.plate_select ||
                form.plate_info ||
                form.carpet_color ||
                form.outlet ||
                form.elec_select ||
                (form.elec_detail && form.elec_detail !== 0) ||
                form.add_select ||
                (form.add_detail && form.add_detail !== "A:0,B:0,C:0,D:0");

              const hasStorage = (form.normal_box && form.normal_box !== 0) ||
                (form.other_box && form.other_box !== 0);

              const hasIphone = form.smartphone !== null || (form.add_smartphone && form.add_smartphone > 0);

              const hasAdd = (form.add_smartphone && form.add_smartphone > 0);

              const checkedObj = {
                pack: !!hasPack,
                storage: !!hasStorage,
                iphone: !!hasIphone,
                add: !!hasAdd,
              };

              setChecked(checkedObj);

              return <Comp8PDF formData={form} checked={checkedObj} selectedPlans={plans} />;
              case 'o9':
                return <Comp9PDF formData={form} rentalItems={rentalItems} />;
              case 'o10':
                const hasPC =
                !!(form.move_in ||
                form.move_in_detail ||
                form.move_out ||
                form.move_out_detail ||
                (Array.isArray(form.details) && form.details.length > 0));
                const checkedPCObj ={
                  pc: !!hasPC
                }
                setCheckedPC(checkedPCObj);
                return <Comp10PDF formData={form} items={pcItems} checked={checkedPCObj} />;
              case 'o10_2':
                return <Comp10_2PDF formData={form} />;
              case "o11": {
                return (
                  <Comp11PDF
                    formData={form}
                  />
                );
              }
              case 'o11_2':
                return <Comp11_2PDF formData={form} />;
              case 'o12':
                const hasGarbage = form.garbage_plan;
                const hasOil = form.lubricating_oil || form.waste_oil;
                const hasClean = form.cleanup;

                const cleanObj = {
                  garbage: !!hasGarbage,
                  oil: !!hasOil,
                  clean: !!hasClean,
                };

                setCleanChecked(cleanObj);
                return <Comp12PDF formData={form} checked={cleanObj} />;
              case 'o13':
                return <Comp13PDF formData={form} />;
              case 'o16':
              return <Comp16PDF formData={form} />;
              case 'o17':
                return <Comp17PDF formData={form} />;
              case 'r18':
                return <Comp18PDF formData={form} />;
              default:
                return <p>フォームが見つかりませんでした</p>;
            }
          };

          root.render(
            <div
              style={{
                width: "210mm",
                minHeight: "297mm",
                padding: "10mm",
                background: "#fff",
                overflow: "visible",
              }}
            >
              {renderComponent(fieldKey)}
            </div>
          );

          const baseUrl =
          window.location.hostname === 'localhost'
            ? 'http://127.0.0.1:8000'          // ローカル開発用
            : 'https://ex-link.net'; // 本番 HTTPS

          await waitForIdleAndStableDOM(container);
          container.style.height = `${container.scrollHeight}px`;

          // ---- ここを差し替え ----
          if (fieldKey === "o13") {
            // ZIP先にダウンロード
            const res = await fetch(`${baseUrl}/api/o13/download/${row.exhibitor_id}`, { cache: "no-store" });
            if (!res.ok) throw new Error("zip ダウンロード失敗");
            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${row.company_name}_ブース平面図.zip`;
            a.click();
            window.URL.revokeObjectURL(url);

            await waitForIdleAndStableDOM(container);

            const canvas = await html2canvas(container, { scale:2, useCORS:true, allowTaint:true, backgroundColor:"#fff" });
            const imgData = canvas.toDataURL("image/jpeg", 0.6);
            const pdf = new jsPDF({
              orientation: "p",
              unit: "mm",
              format: "a4",
              compress: true,
            });
            pdf.addImage(imgData, "JPEG",0,0,210,(canvas.height*210)/canvas.width);
            pdf.save(`${row.company_name}_o13.pdf`);

          } else {
            // o13以外はPDF生成 → その場でダウンロード
            const canvas = await html2canvas(container, {
              scale: 1.3,
              useCORS: true,
              allowTaint: true,
              backgroundColor: "#ffffff",
            });

          const imgData = canvas.toDataURL("image/jpeg", 0.6);
            const imgWidth = 210;
            const pageHeight = 297;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const pdf = new jsPDF({
              orientation: "p",
              unit: "mm",
              format: "a4",
              compress: true,
            });
            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft > 0) {
              position -= pageHeight;
              pdf.addPage();
              pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
              heightLeft -= pageHeight;
            }

            const company = row.company_name || "output";
            const safeCompany = company.replace(/[\\/:*?"<>|]/g, '_');
            const label = fieldConfig.label || fieldKey;

            // ✅ここで即ダウンロード
            pdf.save(`${safeCompany}_${label}.pdf`);
          }
          // ---- 差し替えここまで ----

          root.unmount();
          document.body.removeChild(container);

          // 次に行く前にちょっと待機（ブラウザ負荷対策）
          await new Promise(res => setTimeout(res, 800));
        }
      }
    };
  return (
    <div>
      <Header
        title="しんきんビジネスマッチング　ビジネスフェア2026 出展者マイページ"
        companyName={mypageData?.company_name}
      />
      <Dialog open={noticeModalOpen} onClose={handleCloseNotice} aria-labelledby="late-fee-notice-title">
        <DialogTitle id="late-fee-notice-title">【要確認！】</DialogTitle>
        <DialogContent>
          <Typography component="p" sx={{ fontWeight: 'bold', mb: 2 }}>
            電気申請、その他備品申請の直前申込について
          </Typography>
          <Typography component="p">
            出展概要（出展の手引き）P33にも記載のあります通り、10月27日（火）以降のお申込み（会場での現地申込を含む）については、直前手配料として、通常料金から50％の割増料金にてご請求させていただきます。
          </Typography>
          <Typography component="p" sx={{ mt: 2 }}>
            申込が必要な場合は、メニューの「お問い合わせ」より、ご連絡ください。
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNotice} color="primary">閉じる</Button>
        </DialogActions>
      </Dialog>
       <style>
        {`
        .form-card.read-only {cursor: default;}
        @media only screen and (max-width: 830px) {
        .sm-block {display: block !important;}
        .sm-none {display: none;}
        .form-status-title,.notice-title,.one-notice-title {font-size: 18px;}
        .form-grid {
          display: flex;
          flex-direction: column;
          gap: 12px;
          padding: 10px;

          /* スクロール気持ちよくする */
          scroll-snap-type: x mandatory;
          -webkit-overflow-scrolling: touch;
        }
        .form-card {
          min-width: 220px; /* ←ここ重要 */
          width: 100%;
          flex: 0 0 auto;

          display: flex;
          align-items: center;
          gap: 10px;

          padding: 12px;
          border-radius: 10px;
          background: #fff;
          border: 1px solid #ddd;

          cursor: pointer;
          transition: 0.2s;

          scroll-snap-align: start;
        }
        .form-grid::-webkit-scrollbar {
          display: none;
        }
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .sm-pad0 {padding-right: 0;padding-left: 0;}
        .sm-p-b-15 {padding-bottom: 15px;}
        .flex-wrap {display: flex;gap: 20px;margin: 10px 15px;width: fit-content;}
        .sm-p-b-15 {gap: 15px;}
        .form-status-title {width: fit-content;}
        .menu-item {background-color: #fff;margin-bottom: 10px;}
        }
        @media only screen and (min-width: 831px) {
        .hamburger_menu_btn_wrap {display: none;}
        .b-b-ash {border-bottom: 1px solid #ccc;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }} className='sm-block'>
        <Container sx={{ width: '22%', mt: 4 }} className='sm-none'>
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
                className={`menu-item`}
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #0071BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#0071bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  if (canDownload) {
                    handlePdfDownload(mypageData.exhibitor_id, mypageData.company_name);
                  }
                }}
                style={{
                  cursor: canDownload ? "pointer" : "not-allowed",
                  opacity: canDownload ? 1 : 0.5,
                }}
              >
                見積書発行
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://shinkin-tokai.sakura.ne.jp/files/polisy.pdf', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
              <Box
                className="menu-item"
                onClick={handleDownloadCertificates}
                // style={{
                //   cursor: canDownloadCertificate ? "pointer" : "not-allowed",
                //   opacity: canDownloadCertificate ? 1 : 0.5,
                // }}
              >
                  車両証をダウンロード
              </Box>
            </Box>
          </Box>
        </Container>
        <HamburgerMenu />
        <Container sx={{ width: {xs:'100%',md: '80%'}}}>
          <p className='remind'>
            締切日: {deadline.toLocaleDateString()}(水)<br />
            {remainingDays > 0
              ? `締め切りまであと${remainingDays}日`
              : "締め切りました"}
          </p>
          {/* <FormRequire /> */}
          <Box sx={{ margin: 'auto', mt: 4 }} className="form-status-box">
            <Box className="sm-column sm-p-b-15" sx={{display:'flex',justifyContent:'space-between',alignItems:'center',borderRadius: '15.68px 15.68px 0 0',backgroundColor:'#7d7d7d'}}>
              <Typography variant="h6" className='form-status-title' gutterBottom>　ビジネスフェア2026各種届出提出状況</Typography>
              <Box className="flex-wrap">
                <Button variant="contained" color="secondary" onClick={handlePDFDownload} disabled={checkedPdfIds.length === 0} sx={{ px: 2 }}>PDFダウンロード</Button>
                <Button variant="contained" color="primary" onClick={handleColumnSelect} sx={{ px: 2 }}>一括チェック</Button>
              </Box>
            </Box>
            <Container className='sm-pad0' sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
              {/* 必須書類のまま */}
              <Typography sx={{textAlign: 'center'}}>必須提出書類</Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-around', borderBottom: '1px solid #ccc', pb: 1 }} className="form-grid b-b-ash">
                  <Box 
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                    }}
                    className="form-card"
                  >
                    <Box sx={{display: 'flex',flexDirection: 'column', alignItems: 'center'}}>
                      <img
                      src={getImageByStatus(
                          getPreferredStatus(
                          statusData?.r1_status,
                          statusData?.r1_host_status,
                          )
                      )}
                      alt="必須書類ステータス"
                      style={{ width: '60px',cursor: 'pointer' }}
                      onClick={() => navigate('/form-require')}
                      />
                      <Checkbox
                        disabled={!isCheckable("r1")}
                        checked={checkedPdfIds.includes("r1")}
                        onChange={(e) => {
                          e.stopPropagation(); // ← これ超重要（遷移防止）
                          togglePdfCheck("r1");
                        }}
                      />
                    </Box>
                    <Typography sx={{cursor: 'pointer'}}>出展責任者登録、搬入・搬出計画登録</Typography>
                  </Box>
                  <Box 
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                    }}
                    className="form-card"
                  >
                    <Box sx={{display: 'flex',flexDirection: 'column', alignItems: 'center'}}>
                      <img
                      src={getImageByStatus(
                          getPreferredStatus(
                          statusData?.r18_status,
                          statusData?.r18_host_status,
                          )
                      )}
                      alt="キャッチコピーステータス"
                      style={{ width: '60px',cursor: 'pointer' }}
                      onClick={() => navigate('/form-r-18')}
                      />
                      <Checkbox
                        disabled={!isCheckable("r18")}
                        checked={checkedPdfIds.includes("r18")}
                        onChange={(e) => {
                          e.stopPropagation(); // ← これ超重要（遷移防止）
                          togglePdfCheck("r18");
                        }}
                      />
                    </Box>
                    <Typography sx={{cursor: 'pointer'}}>キャッチコピー登録</Typography>
                  </Box>
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card"
                  >
                   <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                   <img
                     src={getImageByStatus(
                     getPreferredStatus(
                         statusData?.o11_2_status,
                         statusData?.o11_2_host_status,
                     )
                     )}
                     alt="電気使用申請書ステータス"
                     style={{ width: '60px' }}
                     onClick={() => navigate('/form-o-11_2')}
                   />
                   <Checkbox
                    disabled={!isCheckable("o11_2")}
                     checked={checkedPdfIds.includes("o11_2")}
                     onChange={(e) => {
                       e.stopPropagation(); // ← これ超重要（遷移防止）
                       togglePdfCheck("o11_2");
                     }}
                   />
                  </Box>
                  <Typography>防炎対象物品申請</Typography>
                  </Box>
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card"
                  >
                    <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <img
                      src={getImageByStatus(
                      getPreferredStatus(
                          statusData?.o11_status,
                          statusData?.o11_host_status,
                      )
                      )}
                      alt="電気使用申請書ステータス"
                      style={{ width: '60px' }}
                      onClick={() => navigate('/form-o-11')}
                    />
                    <Checkbox
                      disabled={!isCheckable("o11")}
                      checked={checkedPdfIds.includes("o11")}
                      onChange={(e) => {
                        e.stopPropagation(); // ← これ超重要（遷移防止）
                        togglePdfCheck("o11");
                      }}
                    />
                    </Box>
                    <Typography>危険物品の許可申請</Typography>
                  </Box>
              </Box>

              <Typography sx={{textAlign: 'center'}}>任意提出書類</Typography>

              {/* 任意書類 横4つずつ */}
              <Box sx={{ display: 'flex', justifyContent: 'space-around', pb: 1 }} className="form-grid b-b-ash">
                  {/* 1〜4個目 */}
                  {/* <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card"
                  >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <img
                      src={getImageByStatus(
                      getPreferredStatus(
                          statusData?.o3_status,
                          statusData?.o3_host_status,
                      )
                      )}
                      alt="パッケージプランステータス"
                      onClick={() => navigate('/form-o-3')}
                      style={{ width: '60px' }}
                    />
                    <Checkbox
                      disabled={!isCheckable("o3")}
                      checked={checkedPdfIds.includes("o3")}
                      onChange={(e) => {
                        e.stopPropagation(); // ← これ超重要（遷移防止）
                        togglePdfCheck("o3");
                      }}
                    />
                  </Box>
                  <Typography>運送・会場内荷役作業申込</Typography>
                  </Box> */}

                  {/* <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card"
                  >
                  <Box sx={{display:'flex',flexDirection: 'column',alignItems:'center'}}>
                    <img
                      src={getImageByStatus(
                      getPreferredStatus(
                          statusData?.o4_status,
                          statusData?.o4_host_status,
                      )
                      )}
                      alt="物品販売ステータス"
                      style={{ width: '60px' }}
                      onClick={() => navigate('/form-o-4')}
                    />
                    <Checkbox
                      disabled={!isCheckable("o4")}
                      checked={checkedPdfIds.includes("o4")}
                      onChange={(e) => {
                        e.stopPropagation(); // ← これ超重要（遷移防止）
                        togglePdfCheck("o4");
                      }}
                    />
                  </Box>
                  <Typography>床面工事施工申込</Typography>
                  </Box> */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                    }}
                    className="form-card read-only"
                  >
                    <Box sx={{display:'flex',flexDirection:'column',alignItems: 'center'}}>
                      <img
                        src={getImageByStatus(
                          getPreferredStatus(
                            statusData?.o5_status,
                            statusData?.o5_host_status
                          )
                        )}
                        alt="電気使用申込"
                        style={{ width: '60px' }}
                      />
                      <Checkbox
                        disabled={!isCheckable("o5")}
                        checked={checkedPdfIds.includes("o5")}
                        onChange={(e) => {
                          e.stopPropagation(); // ← これ超重要（遷移防止）
                          togglePdfCheck("o5");
                        }}
                      />
                    </Box>
                    <Typography>電気使用申込</Typography>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                    }}
                    className="form-card read-only"
                  >
                    <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                      <img
                        src={getImageByStatus(
                          getPreferredStatus(
                            statusData?.o6_status,
                            statusData?.o6_host_status
                          )
                        )}
                        alt="電気備品レンタル申込"
                        style={{ width: '60px' }}
                      />
                      <Checkbox
                        disabled={!isCheckable("o6")}
                        checked={checkedPdfIds.includes("o6")}
                        onChange={(e) => {
                          e.stopPropagation(); // ← これ超重要（遷移防止）
                          togglePdfCheck("o6");
                        }}
                      />
                    </Box>
                    <Typography>電気備品レンタル申込</Typography>
                  </Box>

                  {/* <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card"
                  >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <img
                      src={getImageByStatus(
                      getPreferredStatus(
                          statusData?.o7_status,
                          statusData?.o7_host_status,
                      )
                      )}
                      alt="食品取扱関係調査ステータス"
                      style={{ width: '60px' }}
                      onClick={() => navigate('/form-o-7')}
                    />
                    <Checkbox
                      disabled={!isCheckable("o7")}
                      checked={checkedPdfIds.includes("o7")}
                      onChange={(e) => {
                        e.stopPropagation(); // ← これ超重要（遷移防止）
                        togglePdfCheck("o7");
                      }}
                    />
                  </Box>
                  <Typography>給排水・エア・ガス工事申込</Typography>
                  </Box> */}
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card read-only"
                  >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <img
                      src={getImageByStatus(
                      getPreferredStatus(
                          statusData?.o8_status,
                          statusData?.o8_host_status,
                      )
                      )}
                      alt="リース備品申請書ステータス"
                      style={{ width: '60px' }}
                    />
                    <Checkbox
                      disabled={!isCheckable("o8")}
                      checked={checkedPdfIds.includes("o8")}
                      onChange={(e) => {
                        e.stopPropagation(); // ← これ超重要（遷移防止）
                        togglePdfCheck("o8");
                      }}
                    />
                  </Box>
                  <Typography>パッケージ装飾申込</Typography>
                  </Box>
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card read-only"
                  >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <img
                      src={getImageByStatus(
                      getPreferredStatus(
                          statusData?.o9_status,
                          statusData?.o9_host_status,
                      )
                      )}
                      alt="インターネット回線申請書ステータス"
                      style={{ width: '60px' }}
                    />
                    <Checkbox
                      disabled={!isCheckable("o9")}
                      checked={checkedPdfIds.includes("o9")}
                      onChange={(e) => {
                        e.stopPropagation(); // ← これ超重要（遷移防止）
                        togglePdfCheck("o9");
                      }}
                    />
                  </Box>
                  <Typography>装飾備品レンタル申込</Typography>
                  </Box>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-around' , borderBottom: '1px solid #ccc' , pb: 1 }} className="form-grid">
                  {/* 5〜8個目 */}

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card read-only"
                  >
                  <Box sx={{display:'flex',alignItems:'center',flexDirection:'column'}}>
                    <img
                      src={getImageByStatus(
                      getPreferredStatus(
                          statusData?.o10_status,
                          statusData?.o10_host_status,
                      )
                      )}
                      alt="PCレンタル申請書ステータス"
                      style={{ width: '60px' }}
                    />
                    <Checkbox
                      disabled={!isCheckable("o10")}
                      checked={checkedPdfIds.includes("o10")}
                      onChange={(e) => {
                        e.stopPropagation(); // ← これ超重要（遷移防止）
                        togglePdfCheck("o10");
                      }}
                    />
                  </Box>
                  <Typography>PC・ソフトレンタル申込</Typography>
                  </Box>

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card read-only"
                  >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <img
                      src={getImageByStatus(
                      getPreferredStatus(
                          statusData?.o10_2_status,
                          statusData?.o10_2_host_status,
                      )
                      )}
                      alt="インターネット接続申請書ステータス"
                      style={{ width: '60px' }}
                    />
                    <Checkbox
                      disabled={!isCheckable("o10_2")}
                      checked={checkedPdfIds.includes("o10_2")}
                      onChange={(e) => {
                        e.stopPropagation(); // ← これ超重要（遷移防止）
                        togglePdfCheck("o10_2");
                      }}
                    />
                  </Box>
                  <Typography>インターネット接続申込</Typography>
                  </Box>
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card"
                  >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <img
                      src={getImageByStatus(
                      getPreferredStatus(
                          statusData?.o16_status,
                          statusData?.o16_host_status,
                      )
                      )}
                      alt="食品系ステータス"
                      style={{ width: '60px' }}
                      onClick={() => navigate('/form-o-16')}
                    />
                    <Checkbox
                      disabled={!isCheckable("o16")}
                      checked={checkedPdfIds.includes("o16")}
                      onChange={(e) => {
                        e.stopPropagation(); // ← これ超重要（遷移防止）
                        togglePdfCheck("o16");
                      }}
                    />
                  </Box>
                  <Typography>食品取扱関係調査票・食品販売申込</Typography>
                  </Box>
                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card"
                  >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <img
                      src={getImageByStatus(
                      getPreferredStatus(
                          statusData?.o17_status,
                          statusData?.o17_host_status,
                      )
                      )}
                      alt="物品ステータス"
                      style={{ width: '60px' }}
                      onClick={() => navigate('/form-o-17')}
                    />
                    <Checkbox
                      disabled={!isCheckable("o17")}
                      checked={checkedPdfIds.includes("o17")}
                      onChange={(e) => {
                        e.stopPropagation(); // ← これ超重要（遷移防止）
                        togglePdfCheck("o17");
                      }}
                    />
                  </Box>
                  <Typography>物品販売申込</Typography>
                  </Box>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-around', pb: 2 }} className="form-grid">
                  {/* 9〜11個目 */}
                  
                  {/* <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24.5%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card"
                  >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <img
                      src={getImageByStatus(
                      getPreferredStatus(
                          statusData?.o12_status,
                          statusData?.o12_host_status,
                      )
                      )}
                      alt="ガス使用申請書ステータス"
                      style={{ width: '60px' }}
                      onClick={() => navigate('/form-o-12')}
                    />
                    <Checkbox
                      disabled={!isCheckable("o12")}
                      checked={checkedPdfIds.includes("o12")}
                      onChange={(e) => {
                        e.stopPropagation(); // ← これ超重要（遷移防止）
                        togglePdfCheck("o12");
                      }}
                    />
                  </Box>
                  <Typography>ゴミ・廃材・廃油処理と小間内清掃申込</Typography>
                  </Box> */}

                  <Box
                  sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '24%',
                      borderRight: '1px solid #ccc',
                      padding: '0 10px',
                      boxSizing: 'border-box',
                      gap: 1,
                      cursor: 'pointer',
                      '&:last-child': { borderRight: 'none' },
                  }}
                  className="form-card"
                  >
                  <Box sx={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                    <img
                      src={getImageByStatus(
                      getPreferredStatus(
                          statusData?.o13_status,
                          statusData?.o13_host_status,
                      )
                      )}
                      alt="水道使用申請書ステータス"
                      style={{ width: '60px' }}
                      onClick={() => navigate('/form-o-13')}
                    />
                    <Checkbox
                      disabled={!isCheckable("o13")}
                      checked={checkedPdfIds.includes("o13")}
                      onChange={(e) => {
                        e.stopPropagation(); // ← これ超重要（遷移防止）
                        togglePdfCheck("o13");
                      }}
                    />
                  </Box>
                  <Typography>ブース平面図</Typography>
                  </Box>
              </Box>
              </Container>
          </Box>
          <Box sx={{ mt: 6 }} className="notice-box" id="news">
            <Typography variant="h6" className='notice-title' gutterBottom>
              しんきんビジネスフェア事務局からのお知らせ
            </Typography>

            {notices
              .filter((notice) => notice.visibility_setting !== '協力会社')
              .filter((notice) => {
                const noticeDate = new Date(notice.date); // notice.date を Date オブジェクトに変換
                return noticeDate <= now; // 現在時刻以前のお知らせのみ
              })
              .map((notice, index) => (
                <Box key={index} sx={{ mb: 2, p: 2 , display: 'flex', alignItems: 'center' }} className="sm-column">
                  <Box
                    sx={{
                      display: 'inline-block',
                      px: 2,
                      py: 0.5,
                      mb: 0,
                      mx: 0.5,
                      borderRadius: '4px',
                      backgroundColor:
                        notice.category === '緊急' ? '#c1272d' :
                        notice.category === '重要' ? '#f7931e' :
                        '#0071bc',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '20px'
                    }}
                    className="noti-cate"
                  >
                    {notice.category}
                  </Box>
                  <Typography variant="h6" color="text.secondary" sx={{ mr: 2 }} className='timestamp'>
                    {notice.date}
                  </Typography>
                  <Typography variant="h6" className='one-notice-title'>{notice.title}</Typography>
                  <Link to={`/news/${notice.notice_id}`} component={RouterLink} sx={{ mt: 1, display: 'block' }}>
                    　詳細を見る
                  </Link>
                </Box>
              ))
            }

            {/* ページネーション */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              {Array.from({ length: Math.ceil(total / noticesPerPage) }).map((_, idx) => (
                <Button
                  key={idx}
                  onClick={() => handlePageChange(idx + 1)}
                  variant={page === idx + 1 ? 'contained' : 'outlined'}
                  sx={{ mx: 0.5 }}
                >
                  {idx + 1}
                </Button>
              ))}
            </Box>
          </Box>
        </Container>
       </Container>
       <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
    </div>
  );
};

export default MyPage;
